import { LitElement } from "lit"

/** Base Class for Portal Elements (without Shadow DOM) */
export class PortalElementBase extends LitElement {
    protected createRenderRoot(): HTMLElement | DocumentFragment {
        // Disable shadow dom
        return this
    }
}
